<template>
  <div>
    <modal-cadu v-model="valueData" :width="1131.52" close class="print-move" ref="content">
      <div slot="all" class="pt-10 pb-4 px-10" ref="teste">
        <div slot="header" ref="header" v-if="!loading">
          <v-img
            v-if="!pendencia"
            class="mb-2 logo"
            :src="require('../../../../assets/imgs_unimed/logotipo.png')"
            width="98"
            height="35"
            min-width="98"
            max-width="98"
          />

          <div class="primary1--text font-secundaria headline font-weight-bold color-print">
            {{ title }}
          </div>
          <div class="subtitle-2 my-4 fontColor--text font-color-print font-secundaria">
            <div><span class="primary1--text color-print"> Unimed: </span> {{ objHeader.unimed }}</div>
            <div>
              <span class="primary1--text color-print"> Tipo de Cooperativa: </span> {{ objHeader.tipoCooperativa }}
            </div>
            <div><span class="primary1--text color-print"> Tipo de Atuação: </span> {{ objHeader.tipoAtuacao }}</div>
            <div>
              <span class="primary1--text color-print"> Data da Atualização: </span> {{ objHeader.dataAtualizacao }}
              <span class="primary1--text color-print"> Horário: </span> {{ objHeader.horario }}
            </div>
            <div>
              <span class="primary1--text color-print"> Nome do Colaborador: </span> {{ objHeader.nomeColaborador }}
            </div>
            <div><span class="primary1--text color-print"> E-mail: </span> {{ objHeader.email }}</div>
            <div><span class="primary1--text color-print"> Telefone: </span> {{ objHeader.telefone }}</div>
            <div><span class="primary1--text color-print"> Versão: </span> {{ objHeader.versao }}</div>
          </div>
        </div>
        <component-loading :value="loading" />
        <div slot="body" v-if="!loading" class="border-body pb-6">
          <div class="block-cards" :style="heightComputed">
            <div v-for="(item, index) in items" :key="index" ref="cards">
              <CardHistorico
                v-if="verificaValores(item)"
                :showIcon="exibeIconeAbrirFechar"
                :arrHistoricoAnterior="item.valoresAntigos"
                :arrHistoricoNova="item.valoresNovos"
                :versaoAnterior="versaoAntiga"
                :versaoNova="versaoNova"
                :titulo="item.nomeItem"
                class="mb-1"
                ref="card-historico"
              />
            </div>
          </div>
        </div>
        <div slot="footer" v-if="title !== 'Comprovante de atualizações – Aplicativo CADU'">
          <v-row align="end" justify="end" class="pt-4 pr-2" v-if="!pendencia">
            <v-col cols="auto">
              <button-cadu text="VOLTAR" @click="$emit('input', false)" />
            </v-col>
          </v-row>
          <v-row align="end" justify="end" class="pt-4 pr-2" v-else>
            <v-col cols="auto">
              <button-cadu
                :backColor="$vuetify.theme.themes.light.warningUtil1"
                text="NEGAR"
                @click="$emit('aprovar', { idUnimed: unimedId, aprovado: false })"
              />
            </v-col>
            <v-col cols="auto">
              <button-cadu text="APROVAR" @click="$emit('aprovar', { idUnimed: unimedId, aprovado: true })" />
            </v-col>
          </v-row>
        </div>
      </div>
    </modal-cadu>
    <error-modal v-model="showError" :errObj="errObj" />
    <overlay-loading v-model="loadingOverlay" />
  </div>
</template>

<script>
import CardHistorico from './CardHistorico'
import VersaoHistorico from '@/services/Historico/VersaoHistorico'
import Pendencia from '@/services/Pendencia/Pendencia'
import ExportarArquivo from '@/services/ExportarArquivo'

export default {
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: String
    },

    pendencia: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    CardHistorico
  },
  data() {
    return {
      valueData: this.value,
      objHeader: {
        unimed: '',
        tipoCooperativa: '',
        tipoAtuacao: '',
        dataAtualizacao: '',
        horario: '',
        nomeColaborador: '',
        email: '',
        telefone: '',
        versao: ''
      },
      loading: false,
      items: [
        { titulo: 'Dados Cadastrais' },
        { titulo: 'Endereço' },
        { titulo: 'Dados Cadastrais' },
        { titulo: 'Endereço' }
      ],
      tokenBearer: localStorage.getItem('tokenBearer'),
      showError: false,
      errObj: {
        status: '',
        error: ''
      },
      unimedId: -1,
      idUnimedNova: -1,
      versaoAntiga: -1,
      versaoNova: -1,
      loadingOverlay: false,
      isExportarArquivo: false
    }
  },
  methods: {
    async imprimirRecibo(id, exportarArquivo) {
      try {
        this.isExportarArquivo = exportarArquivo
        await this.start(id, exportarArquivo)
      } catch (err) {
        this.showError = true
        this.errObj.status = 400
        this.errObj.error = err
      }
    },

    async startReciboPendencia(id) {
      await this.getReciboPendencia(id)
    },

    async start(id, exportarArquivo) {
      this.idUnimedNova = id
      this.isExportarArquivo = exportarArquivo
      await this.loadingWithGetRecibo()
    },

    async loadingWithGetRecibo() {
      this.loading = true
      await this.getRecibo()
      this.loading = false
    },

    async getRecibo() {
      let versaoHistorico = new VersaoHistorico(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        let response = await versaoHistorico.getRecibo(this.idUnimedNova, this.isExportarArquivo)
        if (this.isExportarArquivo) {
          const exportar = new ExportarArquivo(response)
          exportar.arquivo()
        } else {
          response = response.data
          this.items = response.itens
          this.versaoAntiga = response.numeroVersaoAntiga
          this.versaoNova = response.numeroVersaoNova
          this.objHeader = {
            unimed: `${response.codigo} - ${response.nomeFantasia}`,
            tipoCooperativa: response.tipoUnimed,
            tipoAtuacao: response.tipoAtuacao ? response.tipoAtuacao : 'Não tem',
            dataAtualizacao: response.dataAtualizacao,
            horario: response.horarioAtualizacao,
            nomeColaborador: response.usuarioAtualizacao,
            email: response.emailUsuario,
            telefone: response.telefoneUsuario,
            versao: response.numeroVersaoNova
          }
        }
      } catch (err) {
        console.error(err)
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.message
      }
    },

    async getReciboPendencia(id) {
      this.loading = true
      this.unimedId = id
      let pendencia = new Pendencia(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        let response = await pendencia.getRecibo(this.unimedId)
        response = response.data
        this.items = response.itens
        this.versaoAntiga = response.numeroVersaoAntiga
        this.versaoNova = response.numeroVersaoNova
        this.objHeader = {
          unimed: `${response.codigo} - ${response.nomeFantasia}`,
          tipoCooperativa: response.tipoUnimed,
          tipoAtuacao: response.tipoAtuacao ? response.tipoAtuacao : 'Não tem',
          dataAtualizacao: response.dataAtualizacao,
          horario: response.horarioAtualizacao,
          nomeColaborador: response.usuarioAtualizacao,
          email: response.emailUsuario,
          telefone: response.telefoneUsuario,
          versao: response.numeroVersaoNova
        }
        this.loading = false
      } catch (err) {
        this.loading = false
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },

    verificaValores(item) {
      if (this.pendencia) {
        if (item.valoresAntigos || item.valoresNovos)
          return item.valoresAntigos.length > 0 || item.valoresNovos.length > 0

        return false
      }

      return true
    }
  },
  watch: {
    value() {
      this.valueData = this.value
      this.showtemp = this.value
    },
    valueData() {
      if (!this.valueData) {
        this.$emit('input', false)
      }
    }
  },
  computed: {
    heightComputed() {
      return this.title === 'Comprovante de atualizações – Aplicativo CADU'
        ? { 'max-height': '100%' }
        : { 'max-height': '300px' }
    },

    exibeIconeAbrirFechar() {
      return this.title !== 'Comprovante de atualizações – Aplicativo CADU' && !this.pendencia
    }
  }
}
</script>

<style lang="sass" scoped>
.block-cards
  overflow: hidden auto
</style>
